export default __webpack_public_path__ + "static/media/regulatory--speed-limit-zone--g1.981aeede.png";